import { trackLink } from "../../../../../../services/analytics";
import getSingleItemProductString from "../getSingleItemProductString";
import {
  ADOBE_SAVE_SIMILAR_ITEM_FOR_LATER_KEY,
  ADOBE_PRODUCTS_KEY
} from "../../../../../../services/analytics/constants";
import { ITEMS_TYPE_SIMILAR } from "../../constants";
import addToWishlistEvent from "../../../../../../services/dataLayer/addToWishlistEvent";

export const saveForLater = (state, { payload }) => {
  const { saved, productId } = payload;

  if (state.itemsType !== ITEMS_TYPE_SIMILAR || saved === false) {
    return state;
  }

  const newState = {
    ...state,
    trackLink: {
      [ADOBE_PRODUCTS_KEY]: getSingleItemProductString({
        productId,
        quantity: 1
      }),
      events: [ADOBE_SAVE_SIMILAR_ITEM_FOR_LATER_KEY],
      vars: [ADOBE_PRODUCTS_KEY]
    }
  };

  trackLink({ state: newState });

  addToWishlistEvent(payload);

  return newState;
};
